import { render, staticRenderFns } from "./Spheres.vue?vue&type=template&id=1f486a2f"
import script from "./Spheres.vue?vue&type=script&lang=js"
export * from "./Spheres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports